import clsx from "clsx";

import useResponsiveHeight from "../../../hooks/common/useResponsiveHeight";
import { Locale } from "../../../utils/types";
import InfosWrapper from "../../customer-service/InfosWrapper/InfosWrapper";
import LayoutHeader from "./Header/LayoutHeader";

import styles from "./CenteredLayout.module.scss";

interface CenteredLayoutProps {
  children: React.ReactNode;
  showUserMenuOrLoginButton: boolean;
  locale: Locale;
  showLogo?: boolean;
  showFooter?: boolean;
  isWebView?: boolean;
  centered?: boolean;
}

export default function CenteredLayout({
  children,
  showUserMenuOrLoginButton,
  locale,
  showLogo = true,
  showFooter = true,
  isWebView = false,
  centered = false,
}: CenteredLayoutProps): React.ReactElement {
  useResponsiveHeight();

  return (
    <div
      className={clsx(styles.centeredLayout, isWebView && styles.isWebView)}
      data-testid="centered-layout"
    >
      <div
        className={clsx(
          styles.centeredLayoutInner,
          showLogo && styles.withLogo
        )}
        data-testid="centered-layout-inner"
      >
        {/* 웹뷰에서 숨길 헤더·푸터 — hydration 전에도 <html data-webview> CSS 로 숨긴다 (_document.js) */}
        {showLogo && (
          <div className={styles.webViewHidden}>
            <LayoutHeader
              showUserMenuOrLoginButton={showUserMenuOrLoginButton}
              centered={centered}
            />
          </div>
        )}
        {children}
        {showFooter && (
          <div className={styles.webViewHidden}>
            <InfosWrapper locale={locale} />
          </div>
        )}
      </div>
    </div>
  );
}
